import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "d2-icon-delete-minus",
  "use": "d2-icon-delete-minus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" class=\"design-iconfont\" id=\"d2-icon-delete-minus\">\n  <path fill=\"#535353\" d=\"M8 0A8 8 0 1 0 8 16A8 8 0 1 0 8 0Z\" />\n  <path d=\"M3 8H13\" stroke=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol